import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function BellOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>BellOff</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.22897 5.78963C6.61084 6.70645 6.25 7.81108 6.25 9V11.7564C6.25 12.2695 5.88289 12.7839 5.281 13.4174C4.64277 14.0892 4.25 14.9995 4.25 16C4.25 16.9665 5.0335 17.75 6 17.75H7H16C16.8687 17.75 17.5895 17.1171 17.7265 16.2872L16.25 14.8107V16C16.25 16.1381 16.1381 16.25 16 16.25H7H6C5.86193 16.25 5.75 16.1381 5.75 16C5.75 15.3992 5.98449 14.8548 6.36847 14.4506C6.93424 13.8551 7.75 12.9385 7.75 11.7564V9C7.75 8.227 7.95637 7.50219 8.31702 6.87768L7.22897 5.78963ZM16.25 12.6893V9C16.25 6.65279 14.3472 4.75 12 4.75C10.9692 4.75 10.024 5.11701 9.28815 5.72749L8.22408 4.66342C9.23424 3.78312 10.5549 3.25 12 3.25C15.1756 3.25 17.75 5.82436 17.75 9V14.1893L16.25 12.6893Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M3 2L21 20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7976 19.8767C13.6312 20.2179 13.3712 20.5046 13.048 20.7035C12.7247 20.9023 12.3516 21.0051 11.9721 20.9998C11.5926 20.9945 11.2224 20.8813 10.9049 20.6735C10.5873 20.4657 10.3354 20.1718 10.1786 19.8262"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3V4"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
